import React, { useContext } from "react";
import Link from "../../utils/router-compat";
import * as ROUTES from "../../constants/routes";
import { withRouter } from "../../utils/router-compat";
import { withFirebase } from "../Firebase";
import { Context } from "../Cache";
import { getTenantBranding } from "../../utils/branding";

const Navigation = (props) => {
  const { state } = useContext(Context);
  const branding = getTenantBranding(state.config?.appearance);

  return (
    <header className="fixed w-full top-0 z-50 bg-white flex flex-col px-4 py-1 shadow-md">
      <div className="flex flex-row items-center justify-between p-0 w-full">
        <Link to={ROUTES.INCIDENTS_LIST}>
          <div className="font-bold text-base tracking-wide px-2 flex flex-row items-center cursor-pointer">
            <img
              className="object-contain h-10"
              src={branding.logo}
            />
            <div className="ml-4">
              {branding.name}
            </div>
          </div>
        </Link>
      </div>
    </header>
  );
};
export default withRouter(withFirebase(Navigation));
